module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAALZJREFUOE/tlLENwkAMRf+TKBiAhiIFBdNADwMgsQINFSyBxADQwzwpKGgYgALpo4suKAoknCio4spn+57sfyejitleSlpVYw1+T9IW2JV5aqBc0hh4tMFsB1AOZI0gYFQmbQ8kTeL5DNwquQB61b519AE0jZdPP4O+jJfeUQcqFGh9tU6jP2lkuy9pVhP8CNxDzHbaz46geQ10SAVdJWWJa+QCDJvWyEbSQlLRfouFsffAuqx5AshCoRMkhcF1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/mobile.png
// module id = PqiB
// module chunks = 50